import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { verifyInputNumber } from '@/util/commonFuncs'
// import store from '@/store'
import {
  ref,
  toRefs,
  watch,
  withDefaults,
} from 'vue'

interface TrimmingSettingType {
  [key: string]: any
}
interface propertyNameType {
  TRIM_SIDE: string
  TRIM_L_SINGLE: string
  TRIM_L_MOMENT: string
  SECOND_TRIM_VALUE: string
  NEW_TRIM: string
  TRIM: string
  SINGLE_PANEL_TRIM_DIRECTION: string
  IS_FIRST_TRIM_SINGLE_PANEL: string
  IS_DOUBLE_PANEL_FOUR_TRIM: string
  DOUBLE_PANEL_TRIM_SHORT: string
  IS_SINGLE_PANEL_FOUR_TRIM: string
  // 修边补偿
  TRIM_COMPENSATION:string | number
  // 不生成路径设置
  IS_ZERO_NO_ROUTE:string
  
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-trim-setting',
  props: {
    trimmingSetting: { default: () => <TrimmingSettingType>{} },
    source: null,
    isShowSwitch: { type: Boolean, default: false },
    propertyName: null,
    isShowSecondaryCatalog: { type: Boolean, default: true }
  },
  emits: ['onUpdateTrimSetting1', 'onUpdateTrimSetting2'],
  setup(__props: any, { expose, emit }) {

const props = __props as { trimmingSetting: TrimmingSettingType, source: string, isShowSwitch: boolean, propertyName: propertyNameType, isShowSecondaryCatalog: boolean }



const propertyName: propertyNameType = props.propertyName
let { trimmingSetting } = toRefs(props)
const paringPointList = ref([
  { label: 'cuttingDock.cuttingParams.topLeft', value: 'topLeft' },
  { label: 'cuttingDock.cuttingParams.bottomLeft', value: 'bottomLeft' },
  { label: 'cuttingDock.cuttingParams.topRight', value: 'topRight' },
  { label: 'cuttingDock.cuttingParams.bottomRight', value: 'bottomRight' },
]) // 记录修边方向可选项
const imgName = ref('paring')
const singleImgName = ref('paring')
const onlyTrimValue = ref<string[]>([])
function handleParDir(val: string) {
  if(!trimmingSetting.value[propertyName.TRIM] && props.isShowSwitch) return
  trimmingSetting.value[propertyName.TRIM_SIDE] = val
}

function translateLang(key:string){
  return translate(key)
}
function handleClickDirection(val: string) {
  if((propertyName.TRIM in trimmingSetting.value ? !trimmingSetting.value[propertyName.TRIM] : false) || !trimmingSetting.value[propertyName.IS_FIRST_TRIM_SINGLE_PANEL]) return
  trimmingSetting.value[propertyName.SINGLE_PANEL_TRIM_DIRECTION] = val
}
function inputCheck() {
  // 可以为正负数
  let num = [trimmingSetting.value[propertyName.SECOND_TRIM_VALUE]]
  let minusSymbol = num.includes('-') ? '-' : ''
  num = verifyInputNumber(num[0], num, ['0'], '3-5')
  trimmingSetting.value[propertyName.SECOND_TRIM_VALUE] = Number(
    minusSymbol + num
  )
}
let stringObj = ref()
watch(
  () => trimmingSetting.value,
  (newVal) => {
    stringObj.value = JSON.stringify(newVal)
    if (newVal[propertyName.TRIM_L_SINGLE] && newVal[propertyName.DOUBLE_PANEL_TRIM_SHORT]) {
      onlyTrimValue.value = ['long', 'short']
    } else if (newVal[propertyName.TRIM_L_SINGLE]) {
      onlyTrimValue.value = ['long']
    } else if (newVal[propertyName.DOUBLE_PANEL_TRIM_SHORT]) {
      onlyTrimValue.value = ['short']
    } else {
      onlyTrimValue.value = []
    }
    imgName.value = newVal[propertyName.IS_DOUBLE_PANEL_FOUR_TRIM] ? 'cylinder' : 'paring'
    singleImgName.value = newVal[propertyName.IS_SINGLE_PANEL_FOUR_TRIM] ? 'cylinder' : 'paring'
  },
  {
    deep: true,
  }
)
// 修改源数据
watch(
  () => stringObj.value,
  (val) => {
    if (props.source === 'oneDragTwoEngraving') {
      emit('onUpdateTrimSetting2', JSON.parse(val))
    } else {
      emit('onUpdateTrimSetting1', JSON.parse(val))
    }
  }
)
function paringImg(val: string, imgName: string) {
  switch (val) {
    case 'topLeft':
      return require(`../../assets/fiveSixSet/${imgName}LT.png`)
    case 'bottomLeft':
      return require(`../../assets/fiveSixSet/${imgName}LB.png`)
    case 'topRight':
      return require(`../../assets/fiveSixSet/${imgName}RT.png`)
    case 'bottomRight':
      return require(`../../assets/fiveSixSet/${imgName}RB.png`)
  }
  return require(`../../assets/fiveSixSet/${imgName}LT.png`)
}
// 向外部暴露
expose({
  trimmingSetting,
})
// 改变双面板修边
function handleChangeDoubleTrim(value: boolean, key: string) {
  // 修四边
  if (value) {
    key == 'imgName' ? imgName.value = 'cylinder' : singleImgName.value = 'cylinder'
  } else {
    key == 'imgName' ? imgName.value = 'paring' : singleImgName.value = 'paring'
  }
}
function handleChangeOnlyTrim(val: any) {
  if (val.length > 1) {
    val.shift()
  }
  trimmingSetting.value[propertyName.TRIM_L_SINGLE] = val.includes('long') ? true : false
  trimmingSetting.value[propertyName.DOUBLE_PANEL_TRIM_SHORT] = val.includes('short') ? true : false
}
// 修边长度补偿 todo
function inputCheckCompensate(){
  let num = [trimmingSetting.value[propertyName.TRIM_COMPENSATION]]
  let minusSymbol = num.includes('-') ? '-' : ''
  num = verifyInputNumber(num[0], num, ['0'], '3-2')
  let result = Number(minusSymbol + num)
  result = Math.min(result, 999.99)
  trimmingSetting.value[propertyName.TRIM_COMPENSATION] = Number(result)
}


return { __sfc: true,props, emit, propertyName, trimmingSetting, paringPointList, imgName, singleImgName, onlyTrimValue, handleParDir, translateLang, handleClickDirection, inputCheck, stringObj, paringImg, handleChangeDoubleTrim, handleChangeOnlyTrim, inputCheckCompensate }
}

})